import { Component, OnDestroy, OnInit } from '@angular/core';
import { CALENDAR_LOCALE } from '../../services/constant';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-abb-dashboard',
  templateUrl: './abb-dashboard.component.html',
  styleUrls: ['./abb-dashboard.component.scss']
})
export class AbbDashboardComponent implements OnInit, OnDestroy {
  abbNo: string;
  outlet: string;
  currentPage = 1;
  itemsPerPage = 40;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  calendarLocale = CALENDAR_LOCALE.TH;
  loading = false;
  totalItems = 0;
  tableData = [];
  selectedValues: boolean[] = [];
  allChecked: boolean = false;
  modal: NgbModalRef;

  subs: Subscription;

  constructor(
    private alertService: AlertService,
    private apiService: ApiService,
    private modalService: NgbModal,
    private router: Router,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.subs = this.translateService.onLangChange.subscribe(() => {
      this.loadInput();
      this.search();
    });
    this.loadInput();
    this.search();
  }

  loadInput() {
    this.calendarLocale = this.translateService.currentLang === 'en'
      ? CALENDAR_LOCALE.EN
      : CALENDAR_LOCALE.TH;

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  search(resetPageNumber = true) {
    if (resetPageNumber) {
      this.currentPage = 1;
    }
    const params = {
      abb_no: this.abbNo || '',
      outlet: this.outlet || '',
      issue_dt_after: moment(this.startDate).format('YYYY-MM-DD'),
      issue_dt_before: moment(this.endDate).format('YYYY-MM-DD'),
      page: this.currentPage,
      page_size: this.itemsPerPage,
    }
    this.loading = true;
    this.apiService.getAbbData(params).subscribe(
      (response) => {
        this.loading = false;
        this.tableData = response.results;
        this.totalItems = response.count;
        this.selectedValues = Array(this.tableData.length).fill(false);
      },
      (error) => {
        this.loading = false;
        console.error(error);
      },
    );
  }

  clear() {
    this.abbNo = null;
    this.outlet = null;
    this.loadInput();
    this.search();
  }

  pageChanged() {
    this.search(false);
    this.allChecked = false;
  }

  optionChanged() {
    this.search();
  }

  gotoDocumentIssue(data) {
    this.router.navigate(['document', 'issue'], {queryParams: {abbData: data.id}});
  }

  selectDeselectAll(checked: boolean): void {
    this.selectedValues = Array(this.tableData.length).fill(checked);
    this.allChecked = checked;
  }

  isAllSelect(): void {
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i]) {
        this.allChecked = false;
        return;
      }
    }
    this.allChecked = true;
  }

  getSelectId(): string {
    const selectedId = [];
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (this.selectedValues[i]) {
        selectedId.push(this.tableData[i].id);
      }
    }
    return selectedId.join(',');
  }

  getExportExcel() {
    const params = {
      search_box: this.getSelectId(),
    };

    this.apiService.getAbbExcel(params).subscribe(
      (obj) => {
        const currentDate = moment().format('DD-MM-YYYY');
        const filename = `${currentDate}_abb_export.xlsx`;
        this.apiService.createDownloadFile(obj, filename);
      },
    );
  }

  openConfirmationModal(content, data) {
    this.modal = this.modalService.open(content, {backdrop: 'static', centered: true});
    this.modal.result.then((result) => {
      if (!result) {
        return;
      }

      this.apiService.deleteAbbData(data.id).subscribe(
        () => {
          this.alertService.toastNotify({
            type: 'success',
            text: this.translateService.instant('COMMON.SUCCESS-DELETE'),
            timer: 2000,
          });
          this.search();
        },
        (err) => {
          this.alertService.toastNotify({
            type: 'error',
            text: this.translateService.instant('ERROR.TRY-AGAIN'),
            timer: 2000,
          })
        },
      );
    })
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    if (this.modal) {
      this.modal.close();
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/abb-dashboard/abb-dashboard.component.ts